import React from "react";
import { EyeOff } from "lucide-react";
import { twMerge } from "tailwind-merge";
import { roleAvatarBg } from "../../lib/format";

const SIZES = {
  sm: "w-10 h-10 text-[15px]",
  md: "w-12 h-12 text-[18px]",
  lg: "w-16 h-16 text-[28px]",
  host: "w-11 h-11 text-[18px]",
};

/**
 * Quiet circular thumbnail — soft border, no sticker lift.
 */
export default function Thumbnail({
  name,
  role,
  thumbnailUrl,
  hidden = false,
  size = "md",
  className = "",
}) {
  const sizeClass = SIZES[size] || SIZES.md;
  const bgClass = hidden ? "bg-plum text-white" : roleAvatarBg(role);

  return (
    <div
      className={twMerge(
        "rounded-full flex items-center justify-center font-ui font-semibold shrink-0 overflow-hidden border border-black/[0.06]",
        sizeClass,
        thumbnailUrl && !hidden ? "bg-cream" : bgClass,
        className,
      )}
    >
      {hidden ? (
        <EyeOff className="w-5 h-5" strokeWidth={2} />
      ) : thumbnailUrl ? (
        <img
          src={thumbnailUrl}
          alt={name ? `${name} thumbnail` : "Profile thumbnail"}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        (name?.[0] || "?").toUpperCase()
      )}
    </div>
  );
}
